<div class="container-schedule mt-md" nz-row [nzGutter]="[30, 30]">
  <div class="schedules-items" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="14" nzXl="14">
    <p class="text-info mb-xlg">
      {{ disabled ? 'El horario está definido por la sucursal y no se puede modificar' : 'Crea los horarios disponibles' }}
    </p>
    <ng-container>
      <!--DOMINGO-->
      <app-set-hours [disabled]="disabled" [day]="0" [timetable]="days | getTimetableByDay : 0" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
      <nz-divider></nz-divider>
      <!--LUNES-->
      <app-set-hours class="shepherd-item-1" [disabled]="disabled" [day]="1" [timetable]="days | getTimetableByDay : 1" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
      <nz-divider></nz-divider>
      <!--MARTES-->
      <app-set-hours [disabled]="disabled" [day]="2" [timetable]="days | getTimetableByDay : 2" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
      <nz-divider></nz-divider>
      <!--MIERCOLES-->
      <app-set-hours [disabled]="disabled" [day]="3" [timetable]="days | getTimetableByDay : 3" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
      <nz-divider></nz-divider>
      <!--JUEVES-->
      <app-set-hours [disabled]="disabled" [day]="4" [timetable]="days | getTimetableByDay : 4" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
      <nz-divider></nz-divider>
      <!--VIERNES-->
      <app-set-hours [disabled]="disabled" [day]="5" [timetable]="days | getTimetableByDay : 5" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
      <nz-divider></nz-divider>
      <!--SÁBADO-->
      <app-set-hours [disabled]="disabled" [day]="6" [timetable]="days | getTimetableByDay : 6" (addTimetable)="onAddTimetable($event)" (changeTimetableField)="onChange()"></app-set-hours>
    </ng-container>
  </div>
  <div class="schedules-exceptions" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="10" nzXl="10">
    <app-set-hours-exeption [disabled]="disabled" [exceptions]="exceptions" (openNewException)="openModalNewException()"
      (removeException)="removeException($event)"></app-set-hours-exeption>
    <div class="d-flex justify-content-center tw-w-full">
      <button *ngIf="!disabled" [disabled]="disabled" nz-button class="btn-default btn-save-group" nzType="primary" (click)="onSave()"><i nz-icon
          nzType="save" nzTheme="outline"></i>Guardar horarios</button>
    </div>
  </div>
</div>

<!-- modal para agregar nueva excepcion de fecha -->
<nz-modal
  [(nzVisible)]="isVisibleAddNewDateException"
  [nzTitle]="modalTitle"
  [nzClassName]="'modal-m-t-30 modal-add-group'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzWidth]="'620px'"
  (nzOnCancel)="closeModalAddNewDateException(false)">
  <ng-template #modalTitle>
    <div class="container-steps-modal">
      <h2 class="text-title-md-bold">Agregar nueva excepción</h2>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div>
      <nz-range-picker class="shepherd-exception-modal-range-picker tw-mb-0.5" nzInline [required]="true" style="width: 100%;" [(ngModel)]="datesException.dates" [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY"></nz-range-picker>
      <p class="tw-mb-2" nz-typography [nzType]="'danger'" style="font-size: 0.7em" *ngIf="datesException.dateRangeError">{{ datesException.dateRangeError }}</p>
      <p class="tw-mb-3 shepherd-exception-modal-range-text">
        {{
          datesException.dates[0].getTime() === datesException.dates[1].getTime() ?
            (datesException.dates[0] | date:'longDate') :
            ('Del ' + (datesException.dates[0] | date:'longDate') + ' al ' + (datesException.dates[1] | date:'longDate'))
        }}
      </p>
      <p class="mt-md text-info shepherd-exception-modal-range-recurring">Utilizar de forma recurrente <nz-switch class="ml-xs" [(ngModel)]="datesException.recurrent"></nz-switch></p>
      <div class="d-flex justify-content-between mt-xlg">
        <div class="hour-range mr-xlg" style="width: 100%;" *ngIf="datesException.hours && datesException.hours.length> 0; else notHours">
          <div *ngFor="let hourGroup of datesException.hours; index as k" [class.mb-xs]="k <datesException.hours.length -1">
            <div class="range">
              <nz-time-picker class="shepherd-exception-modal-time-start" [nzAllowEmpty]="false" [required]="true" [(ngModel)]="hourGroup.start" nzFormat="HH:mm" [nzPlaceHolder]="'Inicia'"></nz-time-picker>
              <span class="ml-xs mr-xs">-</span>
              <nz-time-picker class="shepherd-exception-modal-time-end" [nzAllowEmpty]="false" [required]="true" [(ngModel)]="hourGroup.end" nzFormat="HH:mm" [nzPlaceHolder]="'Termina'"></nz-time-picker>
              <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="ml-xs icon-action danger shepherd-exception-modal-time-delete" (click)="removeHourGroupToException(k)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </div>
            </div>
            <p nz-typography class="shepherd-exception-modal-time-delete" [nzType]="'danger'" style="font-size: 0.7em" *ngIf="hourGroup.hasError">{{ hourGroup.hasError }}</p>
          </div>
        </div>
        <i class="cursor-pointer text-info align-self-start tw-my-auto shepherd-exception-modal-add-hour" (click)="addHourGroupToException()" nz-icon nzType="plus" nzTheme="outline"></i>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal">
      <button
        style="margin-right: 5px;"
        (click)="closeModalAddNewDateException(false)"
        nz-button nzType="cancel">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        CANCELAR</button>
      <button class="shepherd-exception-modal-add"
        (click)="closeModalAddNewDateException(true)"
        nz-button nzType="primary">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        AGREGAR
      </button>
    </div>
  </ng-template>
</nz-modal>

<ng-template #notHours>
  <p class="text-info align-self-center opacity-30">No hay horarios</p>
</ng-template>
